import "./notAvail.css";

export default function NotAvailable() {
  return (
    <div>
      <h1 className="NA">No movie available for selected genre.</h1>
    </div>
  );
}
